// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import lgcEntity from './entities/lgc.json';
import lgcMenu from '../pages/lgc/menu.json';
import lgcFullForm from '../pages/lgc/forms/full.json';
import lgcContextForm from '../pages/lgc/forms/context.json';
import lgcMiniForm from '../pages/lgc/forms/mini.json';
import lgcLookupForm from '../pages/lgc/forms/lookup.json';
import lgcTableView from '../pages/lgc/views/table.json';
import lgcStagesView from '../pages/lgc/views/stages.json';
import lgcCardsView from '../pages/lgc/views/cards.json';
import lgcInlineView from '../pages/lgc/views/inline.json';
import lgcBacklogView from '../pages/lgc/views/backlog.json';
import lgcSplitView from '../pages/lgc/views/split.json';
import lgcCalendarView from '../pages/lgc/views/calendar.json';
import lgcDashboardView from '../pages/lgc/views/dashboard.json';

/** Тип запису «Судова справа» зі сторінками пакета: меню, форми та подання з pages/lgc/. */
export const lgcDefinition: IRecordTypeDefinition = {
  ...lgcEntity,
  views: assembleViewSet({
      table: lgcTableView,
      stages: lgcStagesView,
      cards: lgcCardsView,
      inline: lgcInlineView,
      backlog: lgcBacklogView,
      split: lgcSplitView,
      calendar: lgcCalendarView,
      dashboard: lgcDashboardView,
  }),
  form: lgcFullForm,
  forms: { full: lgcFullForm, context: lgcContextForm, mini: lgcMiniForm, lookup: lgcLookupForm },
  menu: lgcMenu,
} as IRecordTypeDefinition;
